/* eslint-disable */
import _ from "lodash";

class SceneBase {
  constructor(engine) {
    this.engine = engine;
    this.scene = new BABYLON.Scene(engine);
    this.meshList = {};

    this.cameraPosition = new BABYLON.Vector3(0, 0, 0);
    this.cameraTarget = new BABYLON.Vector3(0, 0, 0);
    this.cameraSpeed = 25;

    this.status = false;

    this.loaded = 0;
    this.loadTotal = 1;
  }

  //------------------------------------
  // Initialize
  //------------------------------------
  init(filename) {
    BABYLON.SceneLoader.ShowLoadingScreen = false;

    let loader = BABYLON.SceneLoader.AppendAsync(
      "/model/",
      filename,
      this.scene,
      event => {
        this.loaded = event.loaded;
        this.loadTotal = event.total;
      }
    );

    loader.animationStartMode = BABYLON.GLTFLoaderAnimationStartMode.NONE;
    loader.compileShadowGenerators = false;

    return loader;
  }

  getLoadStatus() {
    return {
      loaded: this.loaded,
      loadTotal: this.loadTotal
    };
  }

  //------------------------------------
  // setup
  //------------------------------------
  setup() {
    this.initCamera();
    this.initEnvironment();
    this.initPostProcess();

    //Fire
    this.fireMat = this.scene.getMaterialByID("FireMat");
    this.fireTime = 0;
    this.fireInterval = 2;

    this.engine.runRenderLoop(() => {
      this.update();
    });
  }

  //------------------------------------
  // Camera
  //------------------------------------
  initCamera() {
    this.camera = new BABYLON.ArcRotateCamera(
      "Camera",
      0,
      0,
      0,
      new BABYLON.Vector3(0, 0, 0),
      this.scene
    );

    this.camera.maxZ = 1000000;
  }

  //------------------------------------
  // Environment
  //------------------------------------
  initEnvironment() {
    //Sky
    this.skyMat = new BABYLON.SkyMaterial("skyMat", this.scene);
    this.skyMat.backFaceCulling = false;
    this.skyMat.turbidity = 0.1;
    this.skyMat.azimuth = 0.25;
    this.skyMat.inclination = 0.43;
    this.skyMat.luminance = 0.1;
    this.skyMat.rayleigh = 0.005;
    this.skyMat.mieDirectionalG = 0.98;
    this.skyMat.mieCoefficient = 0.005;

    var skybox = BABYLON.Mesh.CreateBox("skyBox", 50000, this.scene);
    skybox.material = this.skyMat;

    //HDR
    let hdrTexture = new BABYLON.CubeTexture("./images/sky", this.scene);
    hdrTexture.gammaSpace = false;
    this.scene.createDefaultSkybox(hdrTexture, true, 100000, 0.25);

    //Pipeline
    this.pipeline = new BABYLON.DefaultRenderingPipeline(
      "default",
      true,
      this.scene,
      [this.camera]
    );

    this.pipeline.imageProcessingEnabled = false;
    this.pipeline.chromaticAberrationEnabled = true;
    this.pipeline.chromaticAberration.aberrationAmount = 200;
    this.pipeline.chromaticAberration.radialIntensity = 4;

    this.pipeline.bloomEnabled = true;
    this.pipeline.bloomThreshold = 0.2;
    this.pipeline.bloomWeight = 0.2;
    this.pipeline.bloomKernel = 64;
    this.pipeline.bloomScale = 0.5;
  }

  initPostProcess() {
    this.time = 0;
    this.wipeStatus = "end";
    this.wipeMax = 10.0;
    this.wipe = this.wipeMax;

    var postProcess = new BABYLON.PostProcess(
      "wipe",
      "/shader/effect",
      ["screenSize", "iTime", "wipe"],
      null,
      1.0,
      this.camera
    );

    postProcess.onApply = effect => {
      effect.setFloat2("screenSize", postProcess.width, postProcess.height);
      effect.setFloat("iTime", this.time);
      effect.setFloat("wipe", this.wipe);
      this.wipeApply();
    };
  }

  wipeApply() {
    switch (this.wipeStatus) {
      case "open":
        this.time += 0.1;
        this.wipe *= 0.95;

        if (this.wipe <= 0.001) {
          this.wipeStatus = "end";
          this.wipe = 0;
          this.time = 0;
        }
        break;
      case "close":
        this.time += 0.1;
        this.wipe += 0.01;

        if (this.wipe >= this.wipeMax) {
          this.wipeStatus = "end";
          this.wipe = 0;
          this.time = 0;
        }
        break;
    }
  }

  wipeOpen() {
    this.wipeStatus = "open";
    this.wipe = this.wipeMax;
  }

  wipeClose() {
    this.wipeStatus = "close";
    this.wipe = 0;
  }

  //------------------------------------
  // Update
  //------------------------------------
  update() {
    this.scene.render();

    //Fire Material
    this.fireTime++;

    if (this.fireTime > this.fireInterval) {
      if (this.fireMat.alpha === 0) {
        this.fireMat.alpha = 1;
      } else {
        this.fireMat.alpha = 0;
      }

      this.fireTime = 0;
    }
  }

  updateCamera(cameraPosition, cameraTarget, speed) {
    let currentPosition = this.camera.position;
    let px = currentPosition.x + (cameraPosition.x - currentPosition.x) / speed;
    let py = currentPosition.y + (cameraPosition.y - currentPosition.y) / speed;
    let pz = currentPosition.z + (cameraPosition.z - currentPosition.z) / speed;
    this.camera.setPosition(new BABYLON.Vector3(px, py, pz));

    let currentTarget = this.camera.target;
    let tx = currentTarget.x + (cameraTarget.x - currentTarget.x) / speed;
    let ty = currentTarget.y + (cameraTarget.y - currentTarget.y) / speed;
    let tz = currentTarget.z + (cameraTarget.z - currentTarget.z) / speed;
    this.camera.setTarget(new BABYLON.Vector3(tx, ty, tz));
  }

  updateRotation(speed) {
    this.getRoot().rotation.y += speed;
  }

  changeStatus(bool) {
    this.status = bool;
  }

  //------------------------------------
  // Get
  //------------------------------------
  getRoot() {
    return this.scene.getMeshByID("__root__");
  }
}
export default SceneBase;
